<div class="ecb-occ-backdrop" (click)="closed.emit()">
  <section class="ecb-occ-dialog" role="dialog" aria-modal="true" aria-labelledby="occ-title" (click)="$event.stopPropagation()">
    <header class="ecb-occ-heading">
      <div><span class="ecb-occ-eyebrow"><i class="bi bi-calendar2-check"></i> Choose a training date</span>
        <h2 id="occ-title">{{ options?.title || 'Select a course occurrence' }}</h2>
        <p>Choose an available intake to add this {{ kind === 'SHORT' ? 'short course' : 'qualification' }} to your cart.</p>
      </div>
      <button type="button" class="ecb-occ-close" (click)="closed.emit()" aria-label="Close date selection"><i class="bi bi-x-lg"></i></button>
    </header>
    <div class="ecb-occ-body">
      <div class="ecb-occ-loading" *ngIf="loading"><i class="bi bi-arrow-repeat"></i> Loading available dates...</div>
      <p class="ecb-occ-error" role="alert" *ngIf="error">{{ error }}</p>
      <p class="ecb-occ-empty" *ngIf="!loading && !options?.occurrences?.length">No bookable occurrences are available for this course. Please enquire about upcoming dates.</p>
      <div class="ecb-occ-list" *ngIf="!loading && options?.occurrences?.length">
        <button type="button" *ngFor="let entry of options?.occurrences" class="ecb-occ-option"
                [class.is-selected]="selectedId === entry.id" [disabled]="!canBook(entry)" (click)="selectedId = entry.id" [attr.aria-pressed]="selectedId === entry.id">
          <span class="ecb-occ-radio"><i class="bi bi-check" *ngIf="selectedId === entry.id"></i></span>
          <span class="ecb-occ-date"><strong>{{ entry.startDate | date:'EEE, d MMM yyyy' }}</strong>
            <small *ngIf="entry.endDate && entry.endDate !== entry.startDate">To {{ entry.endDate | date:'d MMM yyyy' }}</small>
            <small *ngIf="entry.time">{{ entry.time }}</small>
          </span>
          <span class="ecb-occ-location"><i class="bi bi-geo-alt"></i> {{ entry.location || 'Location to be confirmed' }}
            <small *ngIf="entry.deliveryMode">{{ entry.deliveryMode }}</small>
          </span>
          <span class="ecb-occ-right"><strong *ngIf="entry.price > 0">{{ entry.price | currency:options?.currency:'symbol':'1.2-2' }}</strong><strong *ngIf="entry.price <= 0">Price not configured</strong>
            <small>{{ entry.seatsAvailable > 0 ? (entry.seatsAvailable + ' seats left') : 'Fully booked' }}</small></span>
        </button>
      </div>
    </div>
    <footer class="ecb-occ-footer"><button type="button" class="ecb-occ-cancel" (click)="closed.emit()">Cancel</button>
      <button type="button" class="ecb-occ-add" (click)="add()" [disabled]="!selected"><i class="bi bi-cart-plus"></i> Add to cart</button>
      <button type="button" class="ecb-occ-view" (click)="addAndViewCart()" [disabled]="!selected">Add &amp; view cart <i class="bi bi-arrow-right"></i></button>
    </footer>
  </section>
</div>
